// src/MenuData.js

const MenuData = [
  // Desserts
  {
    id: 1,
    category: "Desserts",
    name: "Chocolate Cake",
    description: "Rich and creamy chocolate cake with a molten center."
  },
  {
    id: 2,
    category: "Desserts",
    name: "Apple Pie",
    description: "Classic apple pie with a flaky crust and spiced apple filling."
  },
  {
    id: 3,
    category: "Desserts",
    name: "Cheesecake",
    description: "Creamy cheesecake with a graham cracker crust and strawberry topping."
  },
  {
    id: 4,
    category: "Desserts",
    name: "Tiramisu",
    description: "Traditional Italian dessert with layers of coffee-soaked ladyfingers and mascarpone cheese."
  },
  {
    id: 5,
    category: "Desserts",
    name: "Brownie Sundae",
    description: "Warm brownie topped with vanilla ice cream, hot fudge, and whipped cream."
  },
  {
    id: 6,
    category: "Desserts",
    name: "Panna Cotta",
    description: "Silky smooth panna cotta served with a berry compote."
  },
  {
    id: 7,
    category: "Desserts",
    name: "Lemon Tart",
    description: "Tangy lemon tart with a buttery crust and a dollop of whipped cream."
  },
  {
    id: 8,
    category: "Desserts",
    name: "Banoffee Pie",
    description: "Decadent pie with layers of banana, toffee, and whipped cream."
  },
  {
    id: 9,
    category: "Desserts",
    name: "Molten Lava Cake",
    description: "Chocolate cake with a gooey, molten center, served with vanilla ice cream."
  },
  {
    id: 10,
    category: "Desserts",
    name: "Crème Brûlée",
    description: "Classic French dessert with a caramelized sugar crust and creamy custard."
  },

  // Main Course
  {
    id: 11,
    category: "Main Course",
    name: "Grilled Salmon",
    description: "Freshly grilled salmon with a lemon butter sauce."
  },
  {
    id: 12,
    category: "Main Course",
    name: "Spaghetti Carbonara",
    description: "Traditional Italian pasta dish with creamy egg sauce and pancetta."
  },
  {
    id: 13,
    category: "Main Course",
    name: "Chicken Parmesan",
    description: "Breaded chicken breast topped with marinara sauce and melted mozzarella cheese."
  },
  {
    id: 14,
    category: "Main Course",
    name: "Beef Wellington",
    description: "Tender beef fillet wrapped in puff pastry with mushroom duxelles."
  },
  {
    id: 15,
    category: "Main Course",
    name: "Lamb Chops",
    description: "Grilled lamb chops served with mint sauce and roasted vegetables."
  },
  {
    id: 16,
    category: "Main Course",
    name: "Vegetable Stir Fry",
    description: "Assorted vegetables stir-fried in a savory soy sauce, served with rice."
  },
  {
    id: 17,
    category: "Main Course",
    name: "Seafood Paella",
    description: "Spanish rice dish with saffron, shrimp, mussels, and calamari."
  },
  {
    id: 18,
    category: "Main Course",
    name: "Ribeye Steak",
    description: "Juicy ribeye steak cooked to perfection, served with mashed potatoes and gravy."
  },
  {
    id: 19,
    category: "Main Course",
    name: "Pork Chops",
    description: "Grilled pork chops with a honey mustard glaze and steamed broccoli."
  },
  {
    id: 20,
    category: "Main Course",
    name: "Chicken Alfredo",
    description: "Fettuccine pasta with creamy Alfredo sauce and grilled chicken."
  },

  // Bread
  {
    id: 21,
    category: "Bread",
    name: "Garlic Bread",
    description: "Crispy garlic bread with a soft center."
  },
  {
    id: 22,
    category: "Bread",
    name: "Focaccia",
    description: "Italian flatbread topped with olive oil, rosemary, and sea salt."
  },
  {
    id: 23,
    category: "Bread",
    name: "Baguette",
    description: "Classic French bread with a crispy crust and soft interior."
  },
  {
    id: 24,
    category: "Bread",
    name: "Sourdough",
    description: "Tangy sourdough bread with a chewy crust and airy crumb."
  },
  {
    id: 25,
    category: "Bread",
    name: "Ciabatta",
    description: "Italian white bread with a crisp crust and open crumb."
  },
  {
    id: 26,
    category: "Bread",
    name: "Brioche",
    description: "Rich and buttery French bread, perfect for sandwiches and toast."
  },
  {
    id: 27,
    category: "Bread",
    name: "Naan",
    description: "Soft and fluffy Indian flatbread, ideal for dipping."
  },
  {
    id: 28,
    category: "Bread",
    name: "Pita",
    description: "Middle Eastern flatbread with a pocket, great for stuffing."
  },
  {
    id: 29,
    category: "Bread",
    name: "Cornbread",
    description: "Moist and slightly sweet bread made with cornmeal."
  },
  {
    id: 30,
    category: "Bread",
    name: "Pretzel",
    description: "Soft and chewy pretzel with a golden-brown crust, sprinkled with coarse salt."
  }
];

export default MenuData;
